import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getBusinessDetailedView = createAsyncThunk(
  "profile1/getBusinessDetailedView",
  async (arg, { getState }) => {
    // Accept dealCategoryId string or { dealCategoryId }. Ignore legacy orgId string args.
    // Fall back to Navbar active category so profile refetches stay category-scoped.
    let fromArg;
    if (typeof arg === "string" && arg.startsWith("DCT")) {
      fromArg = arg;
    } else if (arg && typeof arg === "object") {
      fromArg = arg.dealCategoryId;
    }
    const dealCategoryId =
      fromArg || getState()?.dealCategory?.activeCategory?.dealCategoryId;
    const response = await axios.get(`/api/business/getBusinessDetailedView`, {
      params: dealCategoryId ? { dealCategoryId } : undefined,
    });
    return response.response;
  }
);

export const getDropdownData = createAsyncThunk(
  "business/getDropdownData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/business/getIndBusAtList");
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const changePassword = createAsyncThunk(
  "business/changePassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/business/changePassword",
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addSecondaryBank = createAsyncThunk(
  "profile/addSecondaryBank",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/business/addSecondaryBank`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const verifyIfsc = createAsyncThunk(
  "profile/verifyIfsc",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/verifyIfsc", payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editBusDets = createAsyncThunk(
  "profile1/editBusDets",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/editBusDets", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const makeBankPrimary = createAsyncThunk(
  "profile1/makeBankPrimary",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/business/makeBankPrimary",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const removeBank = createAsyncThunk(
  "profile1/removeBank",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/removeBank", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getAllStates = createAsyncThunk(
  "profile/getAllStates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/business/getAllStates");
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const updateAddressDetails = createAsyncThunk(
  "profile/updateAddressDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `/api/business/updateAddressDetails`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendOtp = createAsyncThunk(
  "profile/sendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/sendOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const validateOtp = createAsyncThunk(
  "profile/validateOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/validateOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const editSendOtp = createAsyncThunk(
  "profile/editSendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/editSendOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const editValidateOtp = createAsyncThunk(
  "profile/editValidateOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/business/editValidateOtp",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const sendDepositDetails = createAsyncThunk(
  "profile/sendDepositDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/business/sendDepositDetails",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getAllDesignations = createAsyncThunk(
  "profile1/getAllDesignations",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/business/getAllDesignations");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const BusinessProfileSlice = createSlice({
  name: "profile1",
  initialState: {
    loading: false,
    error: "",
    editOtpError: "",
    businessData: [],
    dropdownData: {},
    otpError: "",
    validateOtpLoading: false,
    passChangeLoading: false,
    passChangeError: null,
    busDetailedViewData: {},
    otpData: {},
    editSendOtpError: null,
    editValidateOtpError: null,
    editOtpData: {},
    editSaveloading: false,
    addBankError: null,
    addBankLoading: false,
    ifscData: {},
    statesData: [],
    editAddLoading: false,
    editAddError: null,
    sendDepositLoading: false,
    sendDepositError: null,
    designations: [],
  },

  extraReducers: (builder) => {
    builder.addCase(getBusinessDetailedView.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBusinessDetailedView.fulfilled, (state, action) => {
      state.loading = false;
      state.busDetailedViewData = action.payload;
    });
    builder.addCase(getBusinessDetailedView.rejected, (state, action) => {
      state.loading = false;
      state.busDetailedViewData = {};
    });

    builder.addCase(makeBankPrimary.pending, (state) => {
      state.error = "";
    });
    builder.addCase(makeBankPrimary.fulfilled, (state, action) => {
      state.error = "";
    });
    builder.addCase(makeBankPrimary.rejected, (state, action) => {
      state.error = action.payload;
    });

    builder.addCase(removeBank.pending, (state) => {
      state.error = "";
    });
    builder.addCase(removeBank.fulfilled, (state, action) => {
      state.error = "";
    });
    builder.addCase(removeBank.rejected, (state, action) => {
      state.error = action.payload;
    });

    builder.addCase(editBusDets.pending, (state) => {
      state.editDetailLoading = true;
      state.editDetailError = "";
    });
    builder.addCase(editBusDets.fulfilled, (state, action) => {
      state.editDetailLoading = false;
      state.editDetailError = "";
    });
    builder.addCase(editBusDets.rejected, (state, action) => {
      state.editDetailLoading = false;
      state.editDetailError = action.payload;
    });

    builder.addCase(getDropdownData.pending, (state) => {
      state.error = "";
    });
    builder.addCase(getDropdownData.fulfilled, (state, action) => {
      state.error = "";
      state.dropdownData = action.payload;
    });
    builder.addCase(getDropdownData.rejected, (state, action) => {
      state.dropdownData = {};
      state.error = action.payload;
    });

    builder.addCase(changePassword.pending, (state) => {
      state.passChangeLoading = true;
      state.passChangeError = null;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.passChangeLoading = false;
      state.passChangeError = null;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.passChangeLoading = false;
      state.passChangeError = action.payload;
    });

    builder.addCase(addSecondaryBank.pending, (state) => {
      state.addBankLoading = true;
      state.addBankError = null;
    });
    builder.addCase(addSecondaryBank.fulfilled, (state, action) => {
      state.addBankLoading = false;
      state.addBankError = null;
    });
    builder.addCase(addSecondaryBank.rejected, (state, action) => {
      state.addBankLoading = false;
      state.addBankError = action.payload;
    });

    builder.addCase(verifyIfsc.pending, (state) => {
      state.error = null;
    });
    builder.addCase(verifyIfsc.fulfilled, (state, action) => {
      state.ifscData = action.payload.response;
      state.error = null;
    });
    builder.addCase(verifyIfsc.rejected, (state, action) => {
      state.ifscData = {};
      state.error = action.payload;
    });

    builder.addCase(getAllStates.fulfilled, (state, action) => {
      state.statesData = action.payload;
    });

    builder.addCase(updateAddressDetails.pending, (state) => {
      state.editAddLoading = true;
      state.editAddError = null;
    });
    builder.addCase(updateAddressDetails.fulfilled, (state, action) => {
      state.editAddLoading = false;
      state.editAddError = null;
    });
    builder.addCase(updateAddressDetails.rejected, (state, action) => {
      state.editAddLoading = false;
      state.editAddError = action.payload;
    });

    builder.addCase(sendOtp.pending, (state) => {
      state.error = null;
    });
    builder.addCase(sendOtp.fulfilled, (state, action) => {
      state.otpData = action.payload;
      state.error = null;
    });
    builder.addCase(sendOtp.rejected, (state, action) => {
      state.otpData = {};
      state.error = action.payload;
    });

    builder.addCase(validateOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.error = null;
    });
    builder.addCase(validateOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.error = null;
    });
    builder.addCase(validateOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.error = action.payload;
    });

    builder.addCase(editSendOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.editSendOtpError = null;
    });
    builder.addCase(editSendOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.otpData = action.payload;
      state.editSendOtpError = null;
    });
    builder.addCase(editSendOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.otpData = {};
      state.editSendOtpError = action.payload;
    });

    builder.addCase(editValidateOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.editValidateOtpError = null;
    });
    builder.addCase(editValidateOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.editValidateOtpError = null;
    });
    builder.addCase(editValidateOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.editValidateOtpError = action.payload;
    });

    builder.addCase(sendDepositDetails.pending, (state) => {
      state.sendDepositLoading = true;
      state.sendDepositError = null;
    });
    builder.addCase(sendDepositDetails.fulfilled, (state, action) => {
      state.sendDepositLoading = false;
      state.sendDepositError = null;
    });
    builder.addCase(sendDepositDetails.rejected, (state, action) => {
      state.sendDepositLoading = false;
      state.sendDepositError = action.payload;
    });

    builder.addCase(getAllDesignations.fulfilled, (state, action) => {
      state.designations = action.payload;
    });
  },

  reducers: {
    clearProfileError: (state) => {
      state.editAddError = null;
      state.addBankError = null;
      state.editDetailError = null;
    },
    clearEditSendOtpError: (state) => {
      state.editSendOtpError = null;
    },
  },
});

export const { clearProfileError, clearEditSendOtpError } = BusinessProfileSlice.actions;

export default BusinessProfileSlice.reducer;
